// src/components/Globe/HexagonLayer.jsx
import { cellToLatLng, latLngToCell, cellToBoundary } from 'h3-js';

// Cache simples para otimizar performance
const boundaryCache = new Map();

// Função pura sem hooks
export const processHexagonData = ({ 
  sensors, 
  zoom, 
  activeLayer,
  getMarkerColor 
}) => {
  
  // Calcular resolução H3 baseada no zoom - MAIS GRANULARIDADE
  // H3 Resolutions: 0 (muito grande ~4.25M km²) até 15 (muito pequeno ~0.9 m²)
  const h3Resolution = (() => {
    if (zoom < 1) return 1;    // Zoom extremamente baixo - hexágonos continentais
    if (zoom < 3) return 2;    // Zoom muito baixo - hexágonos de país
    if (zoom < 4) return 2;    // Zoom baixo - hexágonos regionais (~5.4M km²)
    if (zoom < 5) return 3;    // Zoom baixo-médio - hexágonos estaduais (~680k km²)
    if (zoom < 6) return 3;    // Zoom médio-baixo - hexágonos de região metropolitana (~85k km²)
    if (zoom < 7) return 4;    // Zoom médio - hexágonos de cidade grande (~10.6k km²)
    if (zoom < 8) return 5;    // Zoom médio-alto - hexágonos de cidade (~1.3k km²)
    if (zoom < 9) return 6;    // Zoom alto - hexágonos de bairro (~162 km²)
    if (zoom < 10) return 6;   // Zoom alto - hexágonos de distrito (~20 km²)
    if (zoom < 11) return 7;   // Zoom muito alto - hexágonos de área (~2.5 km²)
    if (zoom < 12) return 7;  // Zoom muito alto - hexágonos de quarteirão (~0.3 km²)
    if (zoom < 13) return 8;  // Zoom extremo - hexágonos de rua (~0.04 km²)
    if (zoom < 14) return 8;  // Zoom extremo - hexágonos de prédio (~0.005 km²)
    if (zoom < 15) return 9;  // Zoom máximo - hexágonos muito pequenos (~0.0006 km²)
    return 10; // Zoom máximo absoluto - hexágonos mínimos (~0.00007 km²)
  })();

  // Agrupar sensores por hexágono
  const hexMap = new Map();
  
  sensors.forEach(sensor => {
    // Permitir sensores com coordenadas v�lidas, mesmo sem dados hist�ricos
if ((!sensor.lat && !sensor.latitude) || (!sensor.lng && !sensor.longitude)) return;
    
    // Converter coordenadas para célula H3
    const h3Index = latLngToCell(
      sensor.lat || sensor.latitude, 
      sensor.lng || sensor.longitude, 
      h3Resolution
    );
    
    if (!hexMap.has(h3Index)) {
      // Usar cache para boundary se disponível
      let boundary;
      if (boundaryCache.has(h3Index)) {
        boundary = boundaryCache.get(h3Index);
      } else {
        boundary = cellToBoundary(h3Index);
        boundaryCache.set(h3Index, boundary);
        
        // Limitar o cache para evitar uso excessivo de memória
        if (boundaryCache.size > 1000) {
          const firstKey = boundaryCache.keys().next().value;
          boundaryCache.delete(firstKey);
        }
      }
      
      hexMap.set(h3Index, {
        hexId: h3Index,
        sensors: [],
        center: cellToLatLng(h3Index),
        boundary: boundary,
        aggregatedData: {
          temperature: [],
          externalTemperature: [],
          humidity: [],
          co2: [],
          quality: [],
          aqi: [],
          pm25: [],
          pm10: []
        }
      });
    }
    
    const hexData = hexMap.get(h3Index);
    hexData.sensors.push(sensor);
    
    // Agregar dados
    if (sensor.temperature !== null) hexData.aggregatedData.temperature.push(sensor.temperature);
    if (sensor.externalTemperature !== null) hexData.aggregatedData.externalTemperature.push(sensor.externalTemperature);
    if (sensor.humidity !== null) hexData.aggregatedData.humidity.push(sensor.humidity);
    if (sensor.co2 !== null) hexData.aggregatedData.co2.push(sensor.co2);
    if (sensor.quality !== null) hexData.aggregatedData.quality.push(sensor.quality);
    if (sensor.aqi !== null) hexData.aggregatedData.aqi.push(sensor.aqi);
    if (sensor.pm25 !== null) hexData.aggregatedData.pm25.push(sensor.pm25);
    if (sensor.pm10 !== null) hexData.aggregatedData.pm10.push(sensor.pm10);
  });
  
  // Calcular médias
  hexMap.forEach((hexData) => {
    const calc = (arr) => arr.length > 0 ? arr.reduce((a, b) => a + b, 0) / arr.length : null;
    
    hexData.averages = {
      temperature: calc(hexData.aggregatedData.temperature),
      externalTemperature: calc(hexData.aggregatedData.externalTemperature),
      humidity: calc(hexData.aggregatedData.humidity),
      co2: calc(hexData.aggregatedData.co2),
      quality: calc(hexData.aggregatedData.quality),
      aqi: calc(hexData.aggregatedData.aqi),
      pm25: calc(hexData.aggregatedData.pm25),
      pm10: calc(hexData.aggregatedData.pm10),
      count: hexData.sensors.length
    };
    
    // Calcular cor baseada na média
    if (activeLayer === 'airQuality' && hexData.averages.aqi !== null) {
      hexData.color = getMarkerColor({ aqi: hexData.averages.aqi });
    } else if (hexData.averages.quality !== null) {
      hexData.color = getMarkerColor({ quality: hexData.averages.quality });
    } else {
      hexData.color = '#808080';
    }
  });
  
  return { 
    hexagonData: Array.from(hexMap.values()), 
    h3Resolution 
  };
};

export default processHexagonData;
